// @ts-nocheck
// Satisfaction Survey — global config (Miscellaneous)
export const FETCH_SURVEY_TEMPLATES_REQUEST = "FETCH_SURVEY_TEMPLATES_REQUEST";
export const FETCH_SURVEY_TEMPLATES_SUCCESS = "FETCH_SURVEY_TEMPLATES_SUCCESS";
export const FETCH_SURVEY_TEMPLATES_FAILURE = "FETCH_SURVEY_TEMPLATES_FAILURE";

export const UPSERT_SURVEY_TEMPLATE_REQUEST = "UPSERT_SURVEY_TEMPLATE_REQUEST";
export const UPSERT_SURVEY_TEMPLATE_SUCCESS = "UPSERT_SURVEY_TEMPLATE_SUCCESS";
export const UPSERT_SURVEY_TEMPLATE_FAILURE = "UPSERT_SURVEY_TEMPLATE_FAILURE";
